import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ShieldCheck } from "lucide-react";
import { Card } from "@/components/ui/Card";
export const OrganizationSecuritySettingsCard = ({ isEnforce2FAEnabled, isLoadingSettings, isUpdatingSettings, onOpenEnable2FAModal })=>{
    return /*#__PURE__*/ _jsx(Card, {
        title: "Security Settings",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ _jsx(ShieldCheck, {
                                    className: "mr-2 h-5 w-5 text-gray-400"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-sm font-medium text-gray-700",
                                            children: "Require Two-Factor Authentication"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mt-0.5 text-xs text-gray-500",
                                            children: "When enabled, all users must set up 2FA to access the organization."
                                        })
                                    ]
                                })
                            ]
                        }),
                        isEnforce2FAEnabled ? /*#__PURE__*/ _jsx("span", {
                            className: "inline-flex items-center rounded-full bg-green-100 px-2.5 py-1 text-xs font-medium text-green-800",
                            children: "Enabled"
                        }) : /*#__PURE__*/ _jsx("button", {
                            onClick: onOpenEnable2FAModal,
                            disabled: isLoadingSettings || isUpdatingSettings,
                            className: "rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                            children: "Enable 2FA Requirement"
                        })
                    ]
                }),
                !isEnforce2FAEnabled && /*#__PURE__*/ _jsx("div", {
                    className: "rounded-lg border border-amber-200 bg-amber-50 p-3",
                    children: /*#__PURE__*/ _jsxs("p", {
                        className: "text-xs text-amber-700",
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                children: "Warning:"
                            }),
                            " Once enabled, 2FA requirement cannot be disabled. All users without 2FA will be required to set it up on their next login."
                        ]
                    })
                }),
                isEnforce2FAEnabled && /*#__PURE__*/ _jsx("div", {
                    className: "rounded-lg border border-green-200 bg-green-50 p-3",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "text-xs text-green-700",
                        children: "Two-factor authentication is enforced. Users without 2FA will be required to set it up on their next login."
                    })
                })
            ]
        })
    });
};
export default OrganizationSecuritySettingsCard;
